import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useGetAllCouponsQuery, useDeleteCouponMutation } from '../../services/couponApi'
import { Add, LocalOfferOutlined } from "@mui/icons-material";
import {
  AdminPageHeader,
  AdminToolbar,
  AdminTable,
  AdminBadge,
  AdminButton,
  AdminRowActions,
  useConfirm,
  useToast,
} from '../../components/ui'

function Coupons() {
  const { data, isLoading } = useGetAllCouponsQuery()
  const [deleteCoupon] = useDeleteCouponMutation()
  const navigate = useNavigate();
  const confirm = useConfirm();
  const toast = useToast();
  const [search, setSearch] = useState("");

  const allRows = data ?? []
  const term = search.trim().toLowerCase();
  const rows = term ? allRows.filter((c) => c.code.toLowerCase().includes(term)) : allRows;

  const handleEdit = (props) => {
    navigate(`/admin/coupon/edit/${props}`);
  };

  const handleDelete = async (coupon) => {
    const ok = await confirm({
      title: "Delete coupon",
      message: `Delete coupon "${coupon.code}"? This can't be undone.`,
      confirmLabel: "Delete",
      danger: true,
    });
    if (!ok) return;
    const res = await deleteCoupon(coupon.id)
    if (res.error) toast.error('Could not delete this coupon.')
    else toast.success("Coupon deleted.")
  }

  const columns = [
    { key: "id", header: "ID", width: 70 },
    { key: "code", header: "Code" },
    { key: "discount", header: "Discount", align: "right", render: (c) => (c.discount_type === 'PERCENT' ? `${c.value}%` : `₹${c.value}`) },
    { key: "min_order_amount", header: "Min Order", align: "right", render: (c) => `₹${c.min_order_amount}` },
    { key: "usage", header: "Usage", align: "right", render: (c) => `${c.times_used}${c.max_uses ? ` / ${c.max_uses}` : ''}` },
    { key: "is_active", header: "Status", render: (c) => <AdminBadge variant={c.is_active ? "success" : "neutral"}>{c.is_active ? "Active" : "Inactive"}</AdminBadge> },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (c) => <AdminRowActions label={c.code} onEdit={() => handleEdit(c.id)} onDelete={() => handleDelete(c)} />,
    },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Coupons"
        subtitle="Create and manage discount codes."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Coupons" }]}
        primaryAction={
          <Link to="/admin/coupon/new">
            <AdminButton icon={<Add />}>New Coupon</AdminButton>
          </Link>
        }
      />
      <AdminToolbar searchValue={search} onSearchChange={setSearch} searchPlaceholder="Search coupons by code..." />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(c) => c.id}
        isLoading={isLoading}
        emptyIcon={<LocalOfferOutlined />}
        emptyTitle={search ? "No coupons match your search" : "No coupons yet"}
        pageSize={10}
      />
    </div>
  );
}

export default Coupons
